import { create } from "zustand";

export type PaletteMode = "closed" | "switcher" | "commands" | "template";

interface PaletteState {
  mode: PaletteMode;
  /** pre-filled query (e.g. "#tag" from the tag browser) */
  initialQuery: string;
  open: (mode: Exclude<PaletteMode, "closed">, initialQuery?: string) => void;
  close: () => void;
}

export const usePalette = create<PaletteState>((set) => ({
  mode: "closed",
  initialQuery: "",
  open: (mode, initialQuery = "") => set({ mode, initialQuery }),
  close: () => set({ mode: "closed", initialQuery: "" }),
}));
